import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@listening/frontend/components/radix/accordion';

type FaqAccordionProps = {
  faqs: Array<{
    question: string;
    answer: string;
  }>;
};

export function FaqAccordion({ faqs }: FaqAccordionProps) {
  return (
    <div className='mx-auto max-w-3xl'>
      <Accordion className='space-y-4' collapsible type='single'>
        {faqs.map(({ question, answer }) => (
          <AccordionItem
            className='group rounded-lg border-none bg-azure-525/10'
            key={question}
            value={question}
          >
            <AccordionTrigger className='flex w-full items-center justify-between p-6 text-left hover:no-underline [&>svg]:size-4'>
              <span className='text-lg font-medium text-gray-900'>
                {question}
              </span>
            </AccordionTrigger>
            <AccordionContent className='p-6 pt-0 text-navy-220/60'>
              <p>{answer}</p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
